import Vue from 'vue';

class StorePrompts {
    'aw.address_address_title' = 'Street address:';
    'aw.address_address' = 'Type to search for your address:';
    'aw.address_apt' = 'Apt., suite, unit, floor etc:';
    'aw.address_area' = 'State:';
    'aw.address_locality' = 'City:';
    'aw.address_zip' = '';
    'aw.and_n_more' = '';
    'aw.am' = 'am';
    'aw.april.short' = '';
    'aw.april' = 'April';
    'aw.august.short' = '';
    'aw.august' = 'August';
    'aw.back_to_list' = '';
    'aw.back' = 'Back';
    'aw.cant_get_map.cancel' = 'Cancel';
    'aw.cant_get_map.retry' = 'Retry';
    'aw.cant_get_map' = 'Failed to load Google Maps API';
    'aw.cant_get_slots.retry' = '';
    'aw.cant_get_slots' = '';
    'aw.chat_header' = '';
    'aw.choose' = 'Select file';
    'aw.clear_filters' = '';
    'aw.close_map' = 'Close map';
    'aw.more_options' = 'More options';
    'aw.collapse' = 'Collapse';
    'aw.combobox_invalid' = '';
    'aw.combobox_placeholder' = 'Select an option';
    'aw.combobox_placeholder_short' = 'Select...';
    'aw.continue' = 'Continue';
    'aw.close' = 'Close';
    'aw.date_from_invalid' = 'The date is out of available ranges';
    'aw.date_non_existing' = 'This is not a valid date';
    'aw.date_to_invalid' = 'The date is out of available range';
    'aw.day_invalid' = '';
    'aw.day' = 'Day';
    'aw.december.short' = '';
    'aw.december' = 'December';
    'aw.doctor' = '';
    'aw.doctors' = '';
    'aw.edit_message' = 'Edit message';
    'aw.error_occurred' = 'Error occurred';
    'aw.february.short' = '';
    'aw.february' = 'February';
    'aw.filters' = '';
    'aw.forward' = 'Forward';
    'aw.friday.letter' = '';
    'aw.friday.short' = 'Fri';
    'aw.friday' = 'Friday';
    'aw.hours_invalid' = '';
    'aw.hours' = '';
    'aw.january.short' = '';
    'aw.january' = 'January';
    'aw.july.short' = '';
    'aw.july' = 'July';
    'aw.june.short' = '';
    'aw.june' = 'June';
    'aw.last_availability' = '';
    'aw.leave_confirmation' = 'Are you sure you want to refresh the flow?';
    'aw.map' = 'Show map';
    'aw.march.short' = '';
    'aw.march' = 'March';
    'aw.may.short' = '';
    'aw.may' = 'May';
    'aw.menu' = 'Menu';
    'aw.minlength_invalid' = '';
    'aw.minutes_invalid' = '';
    'aw.minutes' = '';
    'aw.monday.letter' = '';
    'aw.monday.short' = 'Mon';
    'aw.monday' = 'Monday';
    'aw.month' = 'Month';
    'aw.more' = '';
    'aw.n_doctor' = '{0} doctor';
    'aw.n_doctors' = '{0} doctors';
    'aw.n_filters' = '';
    'aw.n_more' = '';
    'aw.n_selected' = '';
    'aw.next_availability' = '';
    'aw.next_dates' = 'Next dates';
    'aw.no_available_dates' = '';
    'aw.no_found' = 'Nothing found';
    'aw.no' = 'No';
    'aw.november.short' = '';
    'aw.november' = 'November';
    'aw.october.short' = '';
    'aw.october' = 'October';
    'aw.open_camera' = 'Open camera';
    'aw.open_calendar' = 'Open calendar';
    'aw.pagination' = 'Pagination';
    'aw.page_n' = 'page {0}';
    'aw.filter_appointments' = 'Filter appointments';
    'aw.pm' = 'pm';
    'aw.partially_filled_invalid' = '';
    'aw.pattern_invalid' = '';
    'aw.previous_dates' = 'Previous dates';
    'aw.redirect_error_invalid_url' = 'RedirectUrl: Invalid URL provided';
    'aw.redirect_error_no_url' = 'No URL provided';
    'aw.redirect_error_failed' = 'Redirection failed';
    'aw.processing' = 'Processing. Wait a moment...';
    'aw.remove' = 'Remove';
    'aw.request_error' = 'We had some problems processing your answer. Please try again, or refresh your browser if the issue persists — the software may have just been updated.';
    'aw.required_field' = 'Field is required';
    'aw.reset_filters' = 'Reset filters';
    'aw.saturday.letter' = '';
    'aw.saturday.short' = 'Sat';
    'aw.saturday' = 'Saturday';
    'aw.select' = '';
    'aw.september.short' = '';
    'aw.september' = 'September';
    'aw.show_doctors' = '';
    'aw.show_filters' = 'Show filters';
    'aw.signature_cancel' = 'Cancel';
    'aw.signature_clear' = 'Reset';
    'aw.signature_draw' = 'Or draw your signature:';
    'aw.signature_field_title' = 'Type your full name to sign:';
    'aw.signature_hand' = 'Draw It';
    'aw.signature_save' = 'Save';
    'aw.signature_sign_clear' = 'Clear signature';
    'aw.signature_title' = 'Draw your signature below:';
    'aw.sort_by' = '';
    'aw.step_back' = 'Step Back';
    'aw.submit' = 'Submit';
    'aw.resubmit' = 'Resubmit';
    'aw.remove_me' = 'Remove Me';
    'aw.sunday.letter' = '';
    'aw.sunday.short' = 'Sun';
    'aw.sunday' = 'Sunday';
    'aw.swipecard_value' = 'Card swiped';
    'aw.take_photo' = 'Take photo';
    'aw.taking_photo_blocked' = '';
    'aw.textarea_file_invalid' = 'Error occurred, try again';
    'aw.textarea_file_title' = 'Fill from file';
    'aw.thursday.letter' = '';
    'aw.thursday.short' = 'Thu';
    'aw.thursday' = 'Thursday';
    'aw.time' = '';
    'aw.to_search' = 'Type to search';
    'aw.try_again' = 'Try again';
    'aw.tuesday.letter' = '';
    'aw.tuesday.short' = 'Tue';
    'aw.tuesday' = 'Tuesday';
    'aw.upload_image_invalid' = 'Upload error occurred, please try again or contact support team';
    'aw.upload_image_retry' = 'Retry';
    'aw.upload_image_scan' = 'Scan';
    'aw.upload_in_progress' = 'Uploading in progress, please wait';
    'aw.wednesday.letter' = '';
    'aw.wednesday.short' = 'Wed';
    'aw.wednesday' = 'Wednesday';
    'aw.year_invalid' = '';
    'aw.year' = 'Year';
    'aw.yes' = 'Yes';
    'aw.view_all_cards' = 'View all';
    'aw.go_to_date' = 'Go to date';
    'aw.restart_session' = 'Restart session';
    'aw.to_go_fullscreen' = 'Fullscreen';
    'aw.close_fullscreen' = 'Close fullscreen';
    'aw.slots_fetching' = 'Loading appointments...';
    'aw.no_slots' = 'No slots.';
    'aw.waitlist_button' = 'Waitlist Options';
    'aw.waitlist_description' = 'Submit a waitlist request if you would like to be notified when an eligible appointment time becomes available.';
    'aw.waitlist_note' = 'The notification will be sent via sms/text. Please provide your mobile phone.';
    'aw.waitlist_method' = 'Waitlist Method';
    'aw.waitlist_first_available' = 'First Available';
    'aw.waitlist_weekly_availability' = 'Weekly Availability';
    'aw.waitlist_select_provider' = 'Select Provider';
    'aw.select_all' = 'Select All';
    'aw.waitlist_weekday_required' = 'Weekly Availability method requires select at least one day';
    'aw.waitlist_from_time_invalid' = 'From time is required';
    'aw.waitlist_to_time_invalid' = 'To time is required';
    'aw.waitlist_time_range_invalid' = 'To time must be later than From time';
    'aw.waitlist_thank_message' = 'Thank you! We have received your waitlist submission. We will contact you when an appointment becomes available.';
    'aw.waitlist_suggested_description' = 'Are you sure you want to be added to the waitlist for these times? There are available appointment times within your selection.';
    'aw.waitlist_confirm_message' = 'Are you sure you want to be added to the waitlist for these times?';
    'aw.yes_submit' = 'Yes, Submit';
    'aw.and_more' = 'and more';
    'aw.dob_month' = 'Date of birth \u2013 Month';
    'aw.dob_day' = 'Date of birth \u2013 Day';
    'aw.dob_year' = 'Date of birth \u2013 Year';
    'aw.zoom_in' = 'Zoom in';
    'aw.zoom_out' = 'Zoom out';
    'aw.map_control' = 'Map control';
    'aw.got_it' = 'Got it';
    'aw.waitlist_tooltip_description' = 'Having trouble finding the perfect appointment time? View waitlist options here.';
    'aw.waitlist_confirmation_method_section' = 'Waitlist selection';
    'aw.waitlist_confirmation_slot_section' = 'Currently available';
    'aw.waitlist_mobile_phone_title' = 'Mobile Phone';
    'aw.waitlist_mobile_phone_placeholder' = 'Select Mobile Phone';
    'aw.phone_number_invalid' = 'Phone number is invalid';
    'aw.acknowledgement_error_message' = 'Please confirm your acknowledgement';
};

export const storePrompts = new StorePrompts();

export function setPrompts (prompts: Record<string, string>) {
    Object.assign(storePrompts, prompts);
}

export function $trl<K extends keyof StorePrompts> (key: K, ...params: string[]): string {
    let trl = storePrompts[key];
    if (trl && params.length) {
        params.forEach((param, index) => {
            trl = trl.replace(`{${index}}`, param);
        });
    }

    return trl || key;
}

Vue.mixin({
    data () {
        return {
            prompts: storePrompts, // Make storePrompts reactive
        };
    },
    methods: {
        $trl,
    },
});
